import PatientAllergiesV1 from "../../../../components/form_builder/elements/patient_allergies/PatientAllergiesV1.vue";

export default {
  componentName: "fb-patient-allergies-v1",
  component: PatientAllergiesV1,
  defaultAttrs: {
    properties: {
      value: [],
      style: {},
      label: "Patient Allergies",
      description: "",
      eFormEditable: true,
      hidden: false,
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
